import { render } from "./FormationView.vue?vue&type=template&id=ba16cad6&scoped=true"
import script from "./FormationView.vue?vue&type=script&lang=js"
export * from "./FormationView.vue?vue&type=script&lang=js"

import "./FormationView.vue?vue&type=style&index=0&id=ba16cad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba16cad6"]])

export default __exports__